import React from 'react'
import classNames from 'classnames'

import { useMediaQuery } from 'hooks/useMediaQuery'
import style from './style.module.css'

const DESKTOP_HEIGHT = 955
const MOBILE_HEIGHT = 575

type TimelineProps = {
  children: React.ReactNode
  className?: string
}

export function Timeline({ children, className }: TimelineProps) {
  return <ol className={classNames(style.timeline, className)}>{children}</ol>
}

type TimelineItemProps = {
  children: React.ReactNode
  title: string
  duration: number
}

export function TimelineItem({ children, title, duration }: TimelineItemProps) {
  const isMobile = useMediaQuery(`(max-width: 768px)`)
  const height = isMobile ? MOBILE_HEIGHT : DESKTOP_HEIGHT

  return (
    <li
      className={classNames(style.timelineItem, style[title])}
      style={{
        height: (duration / 60) * height,
      }}
    >
      {children}
    </li>
  )
}
